import { render } from "./Arena_CloneMenu.vue?vue&type=template&id=420ccf90&scoped=true"
import script from "./Arena_CloneMenu.vue?vue&type=script&lang=js"
export * from "./Arena_CloneMenu.vue?vue&type=script&lang=js"

import "./Arena_CloneMenu.vue?vue&type=style&index=0&id=420ccf90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-420ccf90"]])

export default __exports__